module.exports = __webpack_public_path__ + "img/team_img_info_none.87131758.png";